module.exports = __webpack_public_path__ + "media/choppy_the_log_surfer.7d0972f3.webm";